import { Tooltip, Typography } from '@mui/material'
import _ from 'lodash'
import { Fragment } from 'react'

interface P {
    value: number
    isInverse?: boolean
    bands: {
        min?: number
        max?: number
        name?: string
        color?: string
        fixedWidth?: number
    }[]
}

function BulletChart({ bands, isInverse, value }: P) {
    const totalFixedWidth = _.sumBy(bands, 'fixedWidth') || 0
    const totalFlexibleWidth = 100 - totalFixedWidth
    const sumFlexibleParts = _.sumBy(bands, band => band.fixedWidth ? 0 : (isInverse ? (band.min ?? 100) - (band.max ?? 0) : (band.max ?? 100) - (band.min ?? 0)))
    let l = 0

    const getBandWidth = (band: P['bands'][0]) => {
        if (band.fixedWidth) {
            return band.fixedWidth
        } else {
            if (isInverse) {
                return (((band.min ?? 100) - (band.max ?? 0)) * (totalFlexibleWidth / sumFlexibleParts))
            } else {
                return (((band.max ?? 100) - (band.min ?? 0))) * (totalFlexibleWidth / sumFlexibleParts)
            }
        }
    }

    const getValueWidth = (value: number) => {
        const bandIndex = isInverse
            ? _.findIndex(bands, x => (x.min ?? 100) >= value && (x.max ?? 0) <= value)
            : _.findLastIndex(bands, x => (x.min ?? 0) <= value && (x.max ?? 100) >= value)

        let prevBandsWidth = 0
        for (let i = 0; i < bandIndex; i++) {
            const band = bands[i]
            prevBandsWidth += getBandWidth(band)
        }

        const band = bands[bandIndex]

        if (band?.fixedWidth) {
            const nextMin = bands[bandIndex + 1]?.min ?? 100
            return prevBandsWidth + (value * band.fixedWidth) / nextMin
        } else {
            const max = isInverse ? band.min : band.max
            return prevBandsWidth + getBandWidth(band) - ((max ?? 100) - value) * (totalFlexibleWidth / sumFlexibleParts)
        }
    }

    return (
        <div className='bullet-chart-container'>
            <div className='bullet-chart-wrapper'>
                {bands.map((band, i) => {
                    const width = getBandWidth(band)
                    l += width

                    return (
                        <Fragment key={i}>
                            <div className='band' style={{ width: width + '%' }}>
                                <div className='band-label'>
                                    <Typography variant='caption'>{band.name}</Typography>
                                </div>
                            </div>
                            {(i < bands.length - 1) &&
                                <div className='tick' style={{ left: l + '%' }} />}
                        </Fragment>
                    )
                })}
                <Tooltip title={_.round(value * 100, 2) + '%'} arrow>
                    <div className='value-indicator' style={{ width: getValueWidth(value * 100) + '%' }} />
                </Tooltip>
            </div>
        </div>
    )
}

export default BulletChart
